// extracted by mini-css-extract-plugin
module.exports = {"root":"filterFooter_root__PdfFg","buttonConfirm":"filterFooter_buttonConfirm__MwHAE"};